import axios from 'axios'
import { ImageUploadError } from 'domain/errors/image-upload-error'
import { isUploadImageUrl } from 'presentation/utils/helpers/helpers'
import { getToken } from './auth'

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { Authorization: getToken() }
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response
      ? error.response.status
      : error
    const url: string = error.response
      ? error.response.config.url
      : error?.config.url
    switch (status) {
      case 401:
        window.location.href = `${process.env.REACT_APP_SIGNIN_URL}/logout`
        break
      case 403:
        if (error.response.data.reason === 'expired_token') {
          window.location.href = `${process.env.REACT_APP_SIGNIN_URL}/login`
        } else {
          window.location.href = `${process.env.REACT_APP_SIGNIN_URL}/logout`
        }
        break
      case 405:
        console.log('Method Not Allowed')
        break
      case 406:
        console.log('Not Acceptable')
        break
      case 422:
        console.log('Unprocessable Entity')
        break
      case 404:
        console.log('ERROR', status)
        break
      default:
        if (!axios.isCancel(error)) {
          if (isUploadImageUrl(url)) {
            throw new ImageUploadError()
          }
          console.log(`Error ${status}`)
        }
    }

    return Promise.reject(error)
  }
)

export default api
